<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="180px" style="width: 100%">
            <el-row :gutter="50">
                <el-col :span="12">
                    <el-form-item label="电子说明书名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入电子说明书名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="电子说明书名称（英文）" prop="enName">
                        <el-input v-model="form.enName" placeholder="请输入电子说明书名称（英文）"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="设备类型" prop="deviceType">
                        <el-select v-model="form.deviceType" placeholder="请选择类型">
                            <el-option label="EVO" value="EVO"></el-option>
                            <el-option label="FP10" value="FP10"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="设备类型（英文）" prop="enDeviceType">
                        <el-select v-model="form.enDeviceType" placeholder="请选择类型（英文）">
                            <el-option label="EVO" value="EVO"></el-option>
                            <el-option label="FP10" value="FP10"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="上传文件" prop="url">
                        <uploader-file v-model="form.url"></uploader-file>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="上传文件（英文）" prop="enUrl">
                        <uploader-file v-model="form.enUrl"></uploader-file>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="handleSubmit">确认</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { detail, edit, add } from "@/api/content/manual";
import UploaderFile from "@/components/UploaderFile.vue";
export default {
    components: { UploaderFile },
    data() {
        return {
            form: {
                name: '',
                deviceType: '',
                url: '',
                enName: '',
                enDeviceType: '',
                enUrl: ''
            },
            rules: {
                name: [{ required: true, message: '请输入电子说明书名称', trigger: 'blur' }],
                deviceType: [{ required: true, message: '请选择设备类型', trigger: 'blur' }],
                url: [{ required: true, message: '请上传文件', trigger: 'blur' }],
                enName: [{ required: true, message: '请输入电子说明书英文名称', trigger: 'blur' }],
                enDeviceType: [{ required: true, message: '请选择英文设备类型', trigger: 'blur' }],
                enUrl: [{ required: true, message: '请上传文件英文地址', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.getDetail(this.$route.query.id);
        }
    },
    methods: {
        getDetail(id) {
            detail({ id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.form = result;
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.form.id) {
                    edit(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    });
                } else {
                    add(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    });
                }
            });
        },
        handleCancel() {
            this.$router.back();
        }
    }
}
</script>

<style></style>
